import styled from '@emotion/styled';

import { capitalizeWords } from '../../../utils/utils';
import CautionIcon from '../../Icons/CautionIcon';
import GiftBagIcon from '../../Icons/GiftBagIcon';
import Tooltip from '../../Tooltip/Tooltip';

interface TableHasConflictTagProps {
  data?: Record<string, any>;
  dataKey?: string;
  totalConflictsKey?: string;
  isRehiredKey?: string;
}

const TableHasConflictTag: React.FC<TableHasConflictTagProps> = ({
  data,
  dataKey,
  totalConflictsKey,
  isRehiredKey,
}) => {
  const d = data ? data : {};
  const label = d[dataKey ?? ''];
  const hasConflict: boolean = d && d[totalConflictsKey ?? ''];
  const isRehired: boolean = d && d[isRehiredKey ?? ''];

  return (
    <Container>
      <TextArea>{capitalizeWords(label)}</TextArea>
      {hasConflict && (
        <Span className='mb'>
          <Tooltip
            content='A hiring conflict was identified based on exclusivity constraints'
            customIcon={<CautionIcon />}
          />
        </Span>
      )}

      {isRehired && (
        <Span>
          {/* <GiftBagIcon /> */}
          <Tooltip
            content='Driver has been rehired'
            customIcon={<GiftBagIcon />}
          />
        </Span>
      )}
    </Container>
  );
};

export default TableHasConflictTag;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 16px 16px;
  align-items: center;
  gap: 8px;
  align-items: center;
`;

const TextArea = styled.div`
  overflow-x: auto;
  max-width: 240px;
  /* white-space: nowrap; */

  /* border: 1px solid red; */

  /* Hide scroll bar */
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Span = styled.span`
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  display: flex;

  /* Reset Tooltip's inline-text offsets so the icon sits centred in the box */
  & > span {
    margin-left: 0;
    top: 0;
  }

  /* &.mb {
    margin-bottom: 2px;
  } */
`;
